import { useState } from 'react'

interface CameraEntrySelection {
    enabled: boolean
    productId: number|null
    labDataId?: number
    variant?: string|null
    model?: string
}

interface CameraEntryState extends CameraEntrySelection {
    startedAt?: number
}

/**
 * Tracks website entry animation outside the R3F scene. Updating the selection
 * state during render lets a replacement scene receive the correct policy
 * before its camera layout effect runs.
 */
export default function useEntryAnimationStartedAt(selection: CameraEntrySelection) {
    const [state, setState] = useState<CameraEntryState>(() => ({
        ...selection,
        startedAt: selection.enabled && selection.labDataId !== undefined
            ? Date.now()
            : undefined,
    }))
    const productChanged = (
        state.productId !== selection.productId
        || state.labDataId !== selection.labDataId
    )
    const selectedViewChanged = (
        state.variant !== selection.variant
        || state.model !== selection.model
    )
    const enabledChanged = state.enabled !== selection.enabled
    let startedAt = state.startedAt

    if(productChanged || selectedViewChanged || enabledChanged) {
        const nextState: CameraEntryState = {
            ...selection,
            startedAt: (
                selection.enabled
                && selection.labDataId !== undefined
                && (productChanged || !state.enabled)
            )
                ? Date.now()
                : undefined,
        }
        setState(nextState)
        startedAt = nextState.startedAt
    }

    return startedAt
}
